import { Bug, Droplet, Leaf, ShieldCheck, Sprout, type LucideIcon } from 'lucide-react';

// Categorias de manejo (telas 06-10). Chave estável usada na rota e no backend.
export const MANEJO_CATS: { key: string; label: string; icon: LucideIcon }[] = [
  { key: 'adubacao', label: 'Adubação', icon: Droplet },
  { key: 'herbicidas', label: 'Herbicidas', icon: Sprout },
  { key: 'fungicidas', label: 'Fungicidas', icon: ShieldCheck },
  { key: 'inseticidas', label: 'Inseticidas', icon: Bug },
  { key: 'nutricao', label: 'Nutrição e Fisiologia', icon: Leaf },
];

export function manejoLabel(key: string): string {
  return MANEJO_CATS.find((c) => c.key === key)?.label ?? 'Manejo';
}
